// ContextualMenuPortal.tsx

import React from "react";
import ReactDOM from "react-dom";
import "./ContextualMenuPortal.scss";

type FloatingRef =
    | ((node: HTMLDivElement | null) => void)
    | React.RefObject<HTMLDivElement>;

interface ContextualMenuProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    className?: string;
    // No anchorPoint here anymore!
    floatingRef: FloatingRef;
    x: number | null;
    y: number | null;
    strategy: "absolute" | "fixed";
}

export default function ContextualMenuPortal({
    isOpen,
    onClose,
    children,
    className = "",
    floatingRef,
    x,
    y,
    strategy,
}: ContextualMenuProps) {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <>
            <div className="contextual-menu__backdrop open" onClick={onClose} />
            <div
                ref={floatingRef}
                className={`contextual-menu ${className} open`}
                style={{
                    position: strategy,
                    top: y ?? 0,
                    left: x ?? 0,
                }}
            >
                {children}
            </div>
        </>,
        document.body,
    );
}
